<div class="sidebar-container">
  <div class="sidebar-list">
      <ng-container *ngFor="let item of items">
          <med-link *ngIf="item.link!=='/reserves' || (item.link==='/reserves' && !isDoz())"
                  mode="left"
                  url="{{item['link']}}">
              <med-icon-car size="24" *ngIf="item.order === '0'"></med-icon-car>
              <med-icon-hospital-building size="24" *ngIf="item.order === '2'"></med-icon-hospital-building>
              <img src="assets/icons/ic24-package.svg" *ngIf="item.order === '1'"/>
              <img src="assets/icons/ic24-pharm-product.svg" *ngIf="item.order === '3'"/>
              <med-icon-transaction size="24" *ngIf="item.order === '4'"></med-icon-transaction>
              <med-icon-book size="24" *ngIf="item.order === '5'"></med-icon-book>
              <med-icon-stopwatch size="24" *ngIf="item.order === '6'"></med-icon-stopwatch>
              &nbsp;<span class="h9-text">{{ item["title"] }}</span>
          </med-link>
      </ng-container>
  </div>
</div>
